import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  LineController,
  BarController,
  Title,
  Tooltip,
  Legend,
  Filler,
  Colors
} from 'chart.js'

// Registrar componentes do Chart.js uma única vez
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  LineController,
  BarController,
  Title,
  Tooltip,
  Legend,
  Filler,
  Colors
)

// Configuração global do Chart.js
export const chartConfig = {
  type: 'line',
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'top' as const,
      labels: {
        usePointStyle: true,
        font: {
          size: 12,
          family: "'Inter', sans-serif"
        },
        color: '#64748b'
      }
    },
    tooltip: {
      enabled: true,
      mode: 'index',
      intersect: false,
      padding: 10,
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      titleColor: '#1e293b',
      bodyColor: '#475569',
      borderColor: '#e2e8f0',
      borderWidth: 1,
      displayColors: true,
      callbacks: {
        label: function(context: any) {
          let label = context.dataset.label || '';
          if (label) {
            label += ': ';
          }
          if (context.parsed.y !== null) {
            label += new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            }).format(context.parsed.y);
          }
          return label;
        }
      }
    },
    colors: {
      enabled: false
    }
  },
  scales: {
    y: {
      beginAtZero: true,
      grid: {
        color: '#f1f5f9',
        drawBorder: false
      },
      ticks: {
        font: {
          size: 11,
          family: "'Inter', sans-serif"
        },
        color: '#64748b',
        padding: 8,
        callback: function(value: any) {
          return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }).format(value);
        }
      }
    },
    x: {
      grid: {
        display: false
      },
      ticks: {
        font: {
          size: 11,
          family: "'Inter', sans-serif"
        },
        color: '#64748b',
        padding: 8
      }
    }
  },
  elements: {
    line: {
      tension: 0.4,
      borderWidth: 2,
      fill: true
    },
    point: {
      radius: 4,
      borderWidth: 2,
      backgroundColor: '#ffffff'
    },
    bar: {
      borderRadius: 4,
      borderWidth: 0
    }
  },
  interaction: {
    intersect: false,
    mode: 'index'
  },
  animation: {
    duration: 1000,
    easing: 'easeInOutQuart'
  }
}

// Configurar padrões globais
ChartJS.defaults.font.family = "'Inter', sans-serif"
ChartJS.defaults.color = '#64748b'
ChartJS.defaults.responsive = true
ChartJS.defaults.maintainAspectRatio = false

// Exportar a instância do Chart.js configurada
export { ChartJS }
